module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/cta1_after_sale2-a7cf7922687dd67e22f11afcc1a73790.png";